import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import useAuthStore from "../../../../store/authStore";

import Button from "../../../../components/components/Button/Button";
import CollectionCard from "../../../components/collectionCard";

const ListCollection = (props) => {
  const { allCollections, artistCollections, loading } = props;
  const { user } = useAuthStore((state) => ({ user: state.userLog }));
  const [collectionsToShow, setCollectionsToShow] = useState(null);
  const navigate = useNavigate();

  const onCollectionClick = (collection_id) => {
    navigate(`/collections/${collection_id}`);
  };

  useEffect(() => {
    if (artistCollections) setCollectionsToShow(artistCollections);
    if (allCollections) setCollectionsToShow(allCollections);
  }, [allCollections, artistCollections]);
  return (
    <div className="row">
      {user && !allCollections && (
        <div className="d-flex justify-content-end">
          <Button
            children="Create Collection"
            onClick={() => navigate("/create-collection")}
          />
        </div>
      )}

      {loading ? (
        <h5>Please wait! Loading collections...</h5>
      ) : collectionsToShow?.length ? (
        collectionsToShow?.map((collections) => (
          <CollectionCard
            key={collections?.id}
            name={collections?.name}
            profileImage={collections?.profileImage}
            coverImage={collections?.coverImage}
            handleCollectionClick={() => onCollectionClick(collections?.id)}
          />
        ))
      ) : (
        <div className="d-flex justify-content-center">
          <p style={{ fontSize: "18px" }}>No collections available.</p>
        </div>
      )}
    </div>
  );
};

export default ListCollection;
